export default __webpack_public_path__ + "static/media/refresh.8425335f.svg";